// extracted by mini-css-extract-plugin
export default {"container":"Footer_container","links":"Footer_links","copyright":"Footer_copyright"};